<div class="advanced-pie-chart">
  <div class="dialog_header pb-15">
    <div class="dialog-title-outer">
      <span *ngIf="data.chartNumber">{{data.chartNumber}}</span>
      <h2 class="dialog_title mb-0" *ngIf="data.chartTitle">{{data.chartTitle | translate}}</h2>
    </div>
      <button type="button" class="bx-btn-icon-fill btn-bg-dark bx-dialog-close-btn flex-none" (click)="closeDilog()">
          <mat-icon>clear</mat-icon>
      </button>
  </div>

  <div id="donut-chart">
    <div class="donut-select-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="selectedOption" (selectionChange)="onAnalyseChange($event)">
          <mat-option [value]="'1'"> {{ 'Zahlen und %' | translate }} </mat-option>
          <mat-option [value]="'2'"> {{ 'nur Zahlen' | translate}} </mat-option>
          <mat-option [value]="'3'"> {{ 'nur %-Satze' | translate }} </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [labels]="chartOptions.labels"
      [responsive]="chartOptions.responsive"
      [legend] = "chartOptions.legend"
      [colors]="chartOptions.colors"
      [plotOptions]="chartOptions.plotOptions"
      [stroke]="chartOptions.stroke"
      [dataLabels]="chartOptions.dataLabels"
      [states]="chartOptions.states"
      [tooltip]="chartOptions.tooltip"
    ></apx-chart>
  </div>
</div> 


  
<!-- <ngx-charts-advanced-pie-chart
  [view]="[700, 400]"
  [results]="data"
  [gradient]="true">
</ngx-charts-advanced-pie-chart> -->